<template>
  <div>
    <h3>Titulo</h3>
    <div>
      <div>
        <a href="#" @click="addNewWidget()">
          <i class="bi bi-plus-square"></i>
        </a>
      </div>
  
      <div class="grid-stack">
        <div class="grid-stack-item-content" gs-x="4" gs-y="0" gs-w="4" gs-h="4">
          <h3>Hola</h3>
          <p>Contenido</p>
        </div>
      </div>
    </div>

    <CRow>
      <CCol col="6" sm="6">
        <SalesParticipationCategoryChart title="Pruebax" :initialDate="'2025-06-01'" :finalDate="'2025-06-01'" reportType="C" utilityType="venta" />
        <!-- <SalesParticipationCategoryChart title="Prueba" :initialDate="fechaInicial" :finalDate="fechaFinal" reportType="C" utilityType="venta" 
                                        :idEmployee="idEmpleado"
                                        :valuesDivisor="divisorValores"
                                        :valuesSing="'M'"
                                        :key="updateComponent" >
                                    </SalesParticipationCategoryChart> -->

      </CCol>
      <CCol col="6" sm="6">
        <CustomerPenetrationChart title="Funnel de Prueba" />
      </CCol>
    </CRow>
  </div>
</template>
<style>
  @import "../../../../node_modules/gridstack/dist/gridstack.min.css";

  .grid-stack {
    background: #FAFAD2;
  }

  .grid-stack-item-content {
    text-align: center;
    background-color: #18bc9c;
  }

  .grid-stack.grid-stack-static {
    background: #060de0;
  }

  .grid-stack-dragging {
    cursor: grabbing;
  }

  .ui-draggable-disabled.ui-resizable-disabled > .grid-stack-item-content {
    background-color: #777;
  }

  .grid-stack-item-removing {
    opacity: 0.5;
  }

  /* make nested grid have slightly darker bg take almost all space (need some to tell them apart) so items inside can have similar to external size+margin */
  .grid-stack > .grid-stack-item.grid-stack-sub-grid > .grid-stack-item-content {
    background: rgba(0, 0, 0, 0.1);
    inset: 0 2px;
  }

  .grid-stack.grid-stack-nested {
    background: none;
    inset: 0;
  }

  .grid-stack.show-dimensions .grid-stack-item:after {
    content: '1x1';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2px;
    color: black;
    background-color: white;
    pointer-events: none;
    /* to not interfere with dragging the item */
  }

  .grid-stack.show-dimensions .grid-stack-item[gs-h]::after {
    content: '1x' attr(gs-h);
  }

  .grid-stack.show-dimensions .grid-stack-item[gs-w]::after {
    content: attr(gs-w) 'x1';
  }

  .grid-stack.show-dimensions .grid-stack-item[gs-h][gs-w]::after {
    content: attr(gs-w) 'x' attr(gs-h);
  }
</style>
<script>
  import { GridStack } from "gridstack";

  import SalesParticipationCategoryChart from "@/components/charts/SalesParticipationCategoryChart.vue";
  import CustomerPenetrationChart from "@/components/charts/CustomerPenetrationChart.vue";

  export default {
    name: "DashboardMarketing",
    data() {
      return {
        grid: undefined,
        loading: false,
        count: 1,
        items: [
          { x: 2, y: 1, h: 2 },
          { x: 2, y: 4, w: 3 },
          { x: 4, y: 2 },
          { x: 3, y: 1, h: 2 },
          { x: 0, y: 6, w: 2, h: 2 }
        ]
      }
    },
    components: {
      SalesParticipationCategoryChart,
      CustomerPenetrationChart
    },
    methods: {
      addNewWidget() {
        this.count++;

        const node = {
          x: Math.round(12 * Math.random()),
          y: Math.round(5 * Math.random()),
          w: Math.round(1 + 3 * Math.random()),
          h: Math.round(1 + 3 * Math.random()),
          id: this.count,
          title: "Pruebita",
          content: `<h3>Panel # ${this.count}</h3>`
        };

        this.grid.addWidget(node);
      }

    },
    computed: {

    },
    setup() {

    },
    mounted() {
      let gridOptions = {
        cellHeight: '70px', 
        minRow: 1,
        margin: 5,
        float: true,
        animate: false

      }
      this.grid = GridStack.init(gridOptions);

      const contenido_dinamico = "<div><h3>Adios</h3><p>Contenido Dinamico</p></div>"

      const node = {
        id: 1,
        title: "Titulo",
        x: 0,
        y: 1,
        w: 6,
        h: 4,
        content: contenido_dinamico
      };

      this.grid.addWidget(node);
      
      this.grid.on("dragstop", (event, element) => {
        console.log(element.gridstackNode)
        const node = element.gridstackNode;

        // `this` will only access your Vue instance if you used an arrow function, otherwise `this` binds to window scope. see https://hacks.mozilla.org/2015/06/es6-in-depth-arrow-functions/
        this.info = `you just dragged node #${node.id} to ${node.x},${node.y} good job!`;
      });
    },
    beforeDestroy() {
      if (this.grid) {
        this.grid.destroy();
      }
    }
  }
</script>
